import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemOoName, FormItemOoNo} from '../OO/FormChooseOo.jsx'
import {FormItemOrName} from '../OR/FormChooseOr.jsx'

export default function FormChooseOr(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemOoNo />
            <FormItemOoName />
            <FormItemOrName />
        </FormChooseExternal>
    )
}
